import ButtonGroup from "@/components/ui/molecules/ButtonGroup/ButtonGroup";
import { useSelectedLinkContext } from "@/contexts";
import { GET_STANDBY_DELAYS } from "@/graphql/admin/settings/SettingsQueries";
import { useQuery } from "@apollo/client";

type AdminSettingsDisplayStandbyProps = {
  value: number;
  onChange: (value: number) => void;
}

const AdminSettingsDisplayStandby = ({ value, onChange }: AdminSettingsDisplayStandbyProps) => {

  const { selectedLink } = useSelectedLinkContext();

  const { data } = useQuery<any>(
    GET_STANDBY_DELAYS,
    {
      variables: {
        getStandbyDelaysInput: {
          channel: selectedLink?.channelKey,
        }
      },
    },
  );

  const options = data?.getStandbyDelays?.delays?.map(option => ({ label: option.label, value: option.value.toString()}));


  return (
    <div className="flex flex-col gap-2w md:flex-row md:items-center md:justify-between">
      <span className='text-body1'>Délai avant la mise en veille</span>
      {data?.getStandbyDelays?.delays && <ButtonGroup className='md:flex-nowrap' options={options} onChange={(value) => onChange(parseInt(value))} value={value === 1 ? '300000' : value?.toString()} />}
    </div>
  );
}

export default AdminSettingsDisplayStandby;